export function validateEmail(email: string | undefined): boolean {
	if (!email) return false
	// eslint-disable-next-line
	const emailRegexp =
		/^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/
	return emailRegexp.test(email)
}
